const dt = require('datatables.net')
require('datatables.net-responsive')

$(document).ready(() => {
  // Configure DataTables to not throw up an alert/popup in error conditions
  // See https://datatables.net/reference/option/$.fn.dataTable.ext.errMode
  $.fn.dataTable.ext.errMode = function (settings, techNote, message) {
    var logger = null
    if (window.console) {
      logger = console.error || console.log
    }
    if (logger) {
      logger(message)
    } else {
      throw new Error(message)
    }
  }

  // Data-tables requires a header row, so add an empty one if not existing
  $('.content-element__content table, .mce-content-body table').each(function () {
    if (!$(this).find('thead').length) {
      var $tr = $('<tr></tr>')
      var firstRow = $(this).find('tr')[0]
      var rowCount = firstRow ? $(firstRow).find('td').length : 0
      for (let i = 0; i < rowCount; i++) {
        $tr.append($('<td></td>'))
      }
      var $th = $('<thead class="datatables--empty-header"></thead>')
      $th.append($tr)
      $(this).prepend($th)
    }

    $(this).DataTable({
      responsive: {
        details: {
          display: $.fn.dataTable.Responsive.display.childRow
        }
      },
      paging: false,
      searching: false,
      info: false,
      order: [] // Don't sort by default
    })
  })
})
